import React from 'react';
import { useSelector } from 'react-redux';

import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  name: '',
  personal: false,
  contact_person: '',
  phone_number: '',
  address: '',
  postal_code: '',
};

export const FormBulkUpdate = ({ data, onSubmit, onClose }) => {
  const StateForm = useSelector((state) => state.Form);
  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const [
    {
      isLoading,
      name,
      contact_person,
      phone_number,
      personal,
      address,
      postal_code,
    },
    setState,
  ] = React.useState(initialState);

  const $onSave = async (c) => {
    const payload = {
      name,
      contact_person: personal ? name : contact_person,
      phone_number,
      address,
      postal_code,
    };

    onSubmit(payload);
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, [isLoading]);

  React.useEffect(() => {
    if (!data) return;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));

    setState((prevState) => ({
      ...prevState,
      name: data?.name,
      personal: data?.name === data?.contact_person ? true : false,
      contact_person: data?.contact_person,
      phone_number: data?.phone_number,
      postal_code: data?.postal_code,
      address: data?.address,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <div className="row m-0">
        {dummy?.map((d, i) => (
          <div key={i} className="col-md-6">
            <SkeletonsForm count={1} key={i} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="px-3 pt-4 pb-3 bg-white my-3 border rounded-2">
      <div className="row text-start">
        <div className="col-12">
          <div className="hr-text hr-text-left text-primary mb-3 ">
            Perbaharui
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group mb-3 ">
            <Form.Input
              value={name || ''}
              required
              type="text"
              label="Nama"
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  name: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.name}
            />

            <Form.Input
              required
              value={contact_person || ''}
              onChange={(e) => {
                setState((prevState) => ({
                  ...prevState,
                  contact_person: e?.target?.value,
                }));
              }}
              type="text"
              label="Kontak Person"
              error={StateForm?.errors?.contact_person}
            />

            <Form.Input
              value={phone_number || ''}
              required
              type="text"
              label="Nomor Handphone"
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  phone_number: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.phone_number}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group mb-3 ">
            <Form.Input
              required
              value={postal_code || ''}
              onChange={(e) => {
                setState((prevState) => ({
                  ...prevState,
                  postal_code: e?.target?.value,
                }));
              }}
              type="text"
              label="Kode Pos"
              error={StateForm?.errors?.postal_code}
            />
            <Form.Textbox
              required
              value={address || ''}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  address: e.target.value,
                }))
              }
              rows={4}
              label="Alamat Lengkap"
              error={StateForm?.errors?.address}
            />
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end align-items-center gap-3 border-top mt-4 pt-3 mb-0">
        <div
          className="btn btn-primary btn-sm rounded-2 px-5 "
          onClick={$onSave}
        >
          Simpan Perubahan
        </div>
        <div className="btn btn-danger btn-sm rounded-2 px-5" onClick={onClose}>
          Batal
        </div>
      </div>
    </div>
  );
};
